import {
  Component,
  Input,
  OnChanges,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { Unit } from '../../../settings-module/models/unit';
import { FormControl, Validators } from '@angular/forms';
import { BlogListingModel } from '../../models/blog-listing.model';

@Component({
  selector: 'mj-overview-listings',
  templateUrl: './overview-listings.component.html',
  styleUrls: ['./overview-listings.component.scss'],
})
export class OverviewListingsComponent implements OnChanges {
  @Input() listings: Array<BlogListingModel>;
  @Input() unit: Unit;
  @Input() access: number;
  @Input() isSticky: boolean;
  @Input() title: string;
  @Input() sortingOptions: any;
  @Input() listingType: string;

  @ViewChild('wrapper', { static: false }) wrapper;

  listingsToDisplay;
  objectKeys = Object.keys;
  selectedSorting = null;
  sortByControl = new FormControl(0, [Validators.required]);

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.unit) {
      this.access = this.unit.role;
    }
    if (changes.listings && this.unit) {
      if (!this.selectedSorting) {
        this.onSort(0);
      } else {
        this.prepareListings(this.listings);
      }
    }
  }

  prepareListings(listings) {
    const listingsToDisplay = {
      [this.unit.name]: [],
    };

    listings.forEach(listing => {
      let unit_name = this.unit.name;
      if (this.listingType === 'blog') {
        unit_name = listing.blog_post.unit.name;
      }
      if (this.listingType === 'job') {
        unit_name = listing.job.unit.name;
      }
      if (this.listingType === 'unit') {
        unit_name = listing.unit.name;
      }
      if (!listingsToDisplay[unit_name]) {
        listingsToDisplay[unit_name] = [];
      }
      listingsToDisplay[unit_name].push(listing);
    });

    this.listingsToDisplay = listingsToDisplay;
  }

  onSort(i) {
    this.selectedSorting = i;
    const sortBy = this.sortingOptions[this.selectedSorting].sortBy;
    if (this.listingType === 'blog') {
      const temp_sort_listing = this.listings as Array<BlogListingModel>;
      this.listings = temp_sort_listing.sort((a, b) => {
        const a_blog_post = a.blog_post;
        const b_blog_post = b.blog_post;
        if (sortBy === 'title') {
          return a_blog_post[sortBy].localeCompare(b_blog_post[sortBy]);
        }
        return b_blog_post[sortBy] < a_blog_post[sortBy] ? -1 : 1;
      });
    }
    this.prepareListings(this.listings);
  }

  searchListings(val) {
    if (this.listingType === 'blog') {
      const temp_filter_listing = this.listings as Array<BlogListingModel>;
      const filteredListings = temp_filter_listing.filter(listing => {
        return (
          listing.blog_post.title.toLowerCase().indexOf(val.toLowerCase()) !==
          -1
        );
      });
      this.prepareListings(filteredListings);
    }
  }
}
